import { initializeAreaCode } from '@common/utils/areaCode'
import { initWorkCardTapSource } from '@common/utils/workCardTapTransition'
import { carousel } from '@pc/components/Carousel'
import { keep, initKeep } from '@pc/components/Keep'
import { searchPageNum, worksLoadImpressionLogs, worksViewImpressionLogs } from '@pc/components/Works/EventTrack'
import { displayGroupWorks } from '@pc/components/Works/Group'
import { listRelatedLink } from '@pc/components/Works/ListRelatedLink'
import { salaryText } from '@pc/components/Works/SalaryText'
import { stickyKeepInfo } from '@pc/components/Works/StickyKeepInfo'
import { workReviewExpand } from '@pc/components/Works/WorkReviewExpand'

document.addEventListener('DOMContentLoaded', () => {
  // Area Code Cookie設定（Fastly対応）
  initializeAreaCode()

  // カードタップ時アニメーション
  initWorkCardTapSource()

  // キープ数の追従
  stickyKeepInfo()

  // リストページ上部、下部にある関連リンク
  listRelatedLink()

  // 提携求人の給与の金額部分だけ赤文字
  salaryText()

  // 口コミの展開
  workReviewExpand()

  // 何ページ目か計測用
  searchPageNum()

  // GA4のインプレッションログ(loadタイプ)
  worksLoadImpressionLogs()

  // GA4のインプレッションログ(viewタイプ)
  worksViewImpressionLogs()

  // その他の求人
  displayGroupWorks()

  // レコメンドのカルーセル
  const wrapper = document.getElementsByClassName('js-works-carousel-wrapper')
  if (wrapper.length > 0) {
    window.addEventListener('load', () => {
      carousel({
        wrapperSelector: '.js-works-carousel-wrapper',
        itemsSelector: '.js-works-carousel-items',
        itemSelector: '.js-works-carousel-item',
        leftCursorSelector: '.js-works-recommend-prev',
        rightCursorSelector: '.js-works-recommend-next',
        visibleItem: 4,
        gap: 20
      })
    })
  }

  // キープ
  keep()
  // 求人ID一覧のキープ状態反映
  initKeep()
})
